import apiFetch from '../apiFetch'
export default function (token, body) {
  return apiFetch({ endPoint: 'UnattendedProcess/SetOperateActionDeletePurchaseProcess', method: 'POST', body: body, token: token })
}
